module.exports = __webpack_public_path__ + "static/img/tu1_jkfa_icon.png";